const _version = "3.7.1"
function version() {
    return _version
}
export default version
